import { render, staticRenderFns } from "./detail-right-menu.vue?vue&type=template&id=17497796&scoped=true"
import script from "./detail-right-menu.vue?vue&type=script&lang=js"
export * from "./detail-right-menu.vue?vue&type=script&lang=js"
import style0 from "./detail-right-menu.vue?vue&type=style&index=0&id=17497796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17497796",
  null
  
)

export default component.exports